import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';

import { Label } from 'core/components/label';
import { observer } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import DialogError from '../dialog-error';

const PurchaseFailed = observer(({ errors, rejections, classes }) => {
  const { offer: store } = useStore();
  const onClick = () => {
    store.triggerOfferDialog(false);
  };

  return (
    <>
      <Label type="titleSecondary" className={classes.title}>
        We were unable to complete the purchase
      </Label>
      {[...errors, ...rejections].map((error) => (
        <DialogError key={error.code} error={error} rawError={store.rawBindErrorMessages} />
      ))}
      <Grid container justifyContent="flex-end" className={classes.bottom}>
        <Button onClick={onClick} variant="contained" color="primary" className={classes.btn}>
          <Label className={classes.btnLabel}>Go back to checkout</Label>
        </Button>
      </Grid>
    </>
  );
});

PurchaseFailed.propTypes = {
  errors: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired
};

export default PurchaseFailed;
